var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C6.94771 0 6.50006 0.447646 6.50006 0.999937V6.00006H1.49994C0.947646 6.00006 0.5 6.44771 0.5 7C0.5 7.55229 0.947646 7.99994 1.49994 7.99994H6.50006V13.0001C6.50006 13.5524 6.94771 14 7.5 14C8.05229 14 8.49994 13.5524 8.49994 13.0001V7.99994H13.5001C14.0524 7.99994 14.5 7.55229 14.5 7C14.5 6.44771 14.0524 6.00006 13.5001 6.00006H8.49994V0.999937C8.49994 0.447646 8.05229 0 7.5 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.419a109dfcac5e15b3ebd892f6fff968.svg";
export { ForwardRef as ReactComponent };